export default{
    async getUserList({ commit }, searchParam){
        const searchData = {
            page: searchParam.options.page,
            per_page: searchParam.options.itemsPerPage,
            sort: {
                key: searchParam.options.sortBy[0],
                asc: !searchParam.options.sortDesc[0]
            },
            search: { ...searchParam.searchKeys }
        };
        commit('setSearchingData', searchData, {root: false});
        return await this.$axios.$post(
            this.$api.tenantAdmin.userList.list,
            searchData
        )
    },

    async getUser({}, id){
        return await this.$axios.$post(
            this.$api.tenantAdmin.userList.userDetail,
            {id : id}
        )
    },

    async editUser({}, userData){
        let result = null;
        await this.$axios.$post(
            this.$api.tenantAdmin.userList.userEdit,
            userData
        )
        .then(response => {
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },

    async createUser({}, userData){
        let result = null;
        await this.$axios.$post(
            this.$api.tenantAdmin.userList.userCreate,
            userData
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
            switch (error.response.status) {
				case 440:
					result = 440;
					break;
				default:
					break;
            }
        })
        return result;
    },

    async resetUserPassword({}, userIdList){
        let result = null;
        await this.$axios.$post(
            this.$api.tenantAdmin.userList.resetPassword,
            {
                'user_id_list': userIdList
            }
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
        })
        return result;
    },

    async downloadUsersCsv({}, params){
        return this.$downloader.downloadPost(this.$axios, this.$api.tenantAdmin.userList.downloadUserCsv, params)
        .catch(error => {
        });
    },

    async downloadGooglePlayCsv({}){
        return this.$downloader.downloadPost(this.$axios, this.$api.tenantAdmin.userList.downloadGooglePlayCsv, {})
        .catch(error => {
        });
    },

    async uploadGooglePlayCsv({}, file){
        let result = null;
        let formData = new FormData;
        formData.append('users[]', file);
        await this.$axios.$post(
            this.$api.tenantAdmin.userList.uploadGooglePlayCsv,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        .then(response => {
            result = 200;
        })
        .catch(error => {
            switch(error.code || '') {
                case 422: 
                    result = 'CSVのフォーマットが不正な為、ファイルを取り込めませんでした。';
                    break;
                default: 
                    result = 'サーバーエラーにより、ファイルを取り込めませんでした。';
                    break;
            }
        })
        return result;
    },

    async getUsersLog({}, params){
        return await this.$axios.$post(
            this.$api.tenantAdmin.userList.usersLog,
            params
        )
    },

    async deleteUser({}, userIdList){
        let result = null;
        await this.$axios.$post(
            this.$api.tenantAdmin.userList.deleteUser,
            {
                'user_id_list': userIdList
            }
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
        })
        return result;
    },


    async getUserCreateInfo(){
        return await this.$axios.$get(
            this.$api.tenantAdmin.userList.userCreateInfo
        )
    }
}